import { Icon, type IconName } from "./icons";
import { useVerificationEnvOptional } from "./env-provider";

const SETTINGS_AREAS: Array<{ label: string; detail: string; path: string; icon: IconName }> = [
  { label: "Account", detail: "Profile, passkeys, and personal preferences", path: "/settings/user/profile", icon: "users" },
  { label: "Agent access", detail: "Local tools, MCP links, observation, and actions", path: "/settings/agents/clis", icon: "code" },
  { label: "Sources", detail: "Connected systems and sync health", path: "/settings/integrations", icon: "plug" },
  { label: "Node and data", detail: "Devices, local authority, sync, and residency", path: "/settings/workspace/team/devices", icon: "server" },
  { label: "Privacy", detail: "Telemetry disclosure and browser-action consent", path: "/settings/agents/telemetry", icon: "eye" },
  { label: "Organization", detail: "People, roles, and shared access", path: "/settings/workspace/team", icon: "lock" },
];

export function CompanionSettings({ onNavigate }: { onNavigate: (to: string) => void }) {
  const env = useVerificationEnvOptional();
  return (
    <main className="vp-companion-settings" data-companion-settings="index" data-route="settings">
      <header className="vp-settings-hero">
        <div className="vp-home-eyebrow">Settings</div>
        <h1>Trust should be easy to inspect and change.</h1>
        <p>Start with the few boundaries that affect what Excellent can observe, where data lives, and who can act. Detailed controls remain inside each area.</p>
      </header>
      <section className="vp-settings-advanced" data-verification-env-reset="">
        <div>
          <span>Environment scope</span>
          <strong>Reset the saved Environment selection and choose a verified target again.</strong>
        </div>
        <div className="vp-home-text-actions">
          <button
            type="button"
            data-action-id="shell.env-reset"
            data-env-reset=""
            onClick={() => env?.resetEnvironment()}
          >
            Reset environment
          </button>
        </div>
      </section>

      <nav className="vp-settings-areas" aria-label="Settings areas">
        {SETTINGS_AREAS.map((area) => (
          <button key={area.path} type="button" data-action-id={`companion-settings.open-${area.label.toLowerCase().replaceAll(" ", "-")}`} onClick={() => onNavigate(area.path)}>
            <span className="vp-settings-icon"><Icon name={area.icon} size={16} /></span>
            <span><strong>{area.label}</strong><small>{area.detail}</small></span>
            <Icon name="caret-right" size={9} />
          </button>
        ))}
      </nav>

      <section className="vp-settings-advanced">
        <div>
          <span>Advanced</span>
          <strong>Security, retention, residency, and custom policy remain available.</strong>
        </div>
        <div className="vp-home-text-actions">
          <button type="button" data-action-id="companion-settings.open-security" onClick={() => onNavigate("/settings/workspace/security")}>Security</button>
          <button type="button" data-action-id="companion-settings.open-data" onClick={() => onNavigate("/settings/advanced/data")}>Data &amp; residency</button>
        </div>
      </section>
    </main>
  );
}
